const DibbleConfigs = {
    apiEndpoint: {
        'development': 'https://api.giverise.app/api',
        'production': 'https://api.giverise.app/api'
    },
};

export default DibbleConfigs;
